import styled from 'styled-components';

export const StyledDashboard = styled.div`
	display: flex;
	height: 100%;
`;
